<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/holiday-management" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>
                {{ $t("system.label.ViewHoliday") }}
              </td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData()"
                      size="small"
                      >{{ $t("system.label.edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("system.label.delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("system.label.HolidayTitle") }}</b>
                    </td>
                    <td>{{ holidayTitle }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.Description") }}</b>
                    </td>
                    <td>{{ description }}</td>
                  </tr>
                  <tr v-if="startDate">
                    <td>
                      <b>{{ $t("setup.label.StartDate") }}</b>
                    </td>
                    <td>
                      {{ startDate ? getDate(startDate) : "" }}
                    </td>
                  </tr>
                  <tr v-if="endDate">
                    <td>
                      <b>{{ $t("setup.label.EndDate") }}</b>
                    </td>
                    <td>
                      {{ endDate ? getDate(endDate) : "" }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.HolidayType") }}</b>
                    </td>
                    <td>{{ holidayType }}</td>
                  </tr>
                  <tr v-if="weeklyHolidays && weeklyHolidays.length > 0">
                    <td>
                      <b>{{ $t("system.label.WeeklyHolidays") }}</b>
                    </td>
                    <td>{{ weeklyHolidays.join(", ") }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.entity") }}</b>
                    </td>
                    <td>
                      <div
                        v-for="(chunk, chunkIndex) in chunkedOffices"
                        :key="chunkIndex"
                      >
                        <span
                          v-for="(office, officeIndex) in chunk"
                          :key="office"
                        >
                          {{ office }}
                          <span
                            v-if="
                              !(
                                chunkIndex === chunkedOffices.length - 1 &&
                                officeIndex === chunk.length - 1
                              )
                            "
                            >,</span
                          >
                        </span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      title="Holiday"
      @deletePressed="deleteUserData()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      delId: 0,
      deleteUserDataPopup: false,
      holidayTitle: "",
      holidayType: "",
      startDate: "",
      endDate: "",
      offices: "",
      description: "",
      weeklyHolidays: [],
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      holidayById: (state) => state.holidayManagement.holidayById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    chunkedOffices() {
      const chunkSize = 4;
      const result = [];
      for (let i = 0; i < this.offices.length; i += chunkSize) {
        result.push(this.offices.slice(i, i + chunkSize));
      }
      return result;
    },
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    editData() {
      this.$router.push(
        `/holiday-management/edit-holiday/${this.$route.params.id}`
      );
    },
    async deleteUserData() {
      this.deleteUserDataPopup = false;
      await this.$store.dispatch(
        "holidayManagement/deleteHolidayAction",
        this.$route.params.id
      );
      this.$vs.notify({
        title: "Sucessfully deleted!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
      this.$router.push(`/holiday-management`);
    },
    async getHolidayByIdMethod() {
      try {
        await this.$store.dispatch(
          "holidayManagement/getHolidayByIdAction",
          this.$route.params.id
        );
        const holidays = this.holidayById;

        if (Array.isArray(holidays) && holidays.length > 0) {
          const firstEntry = holidays[0];

          this.holidayTitle = firstEntry.name;
          this.description = firstEntry.description;
          this.holidayType = firstEntry.holidayType;
          this.offices = holidays.map((h) => h.officeName);
          if (firstEntry.weeklyHolidays) {
            try {
              this.weeklyHolidays = JSON.parse(firstEntry.weeklyHolidays);
            } catch (error) {
              console.error("Failed to parse weeklyHolidays:", error);
            }
          }
          if (firstEntry.fromDate) {
            this.startDate = new Date(
              firstEntry.fromDate[0],
              firstEntry.fromDate[1] - 1,
              firstEntry.fromDate[2]
            );
          }
          if (firstEntry.toDate) {
            this.endDate = new Date(
              firstEntry.toDate[0],
              firstEntry.toDate[1] - 1,
              firstEntry.toDate[2]
            );
          }
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    await this.getHolidayByIdMethod();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
